import { Component, inject, OnInit, resource } from '@angular/core';
import { UsersService } from '../../services/users/users.service';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { fetchAuthSession } from 'aws-amplify/auth';
import mqtt from "mqtt";


@Component({
  selector: 'app-debug',
  imports: [CommonModule],
  templateUrl: './debug.component.html',
  styleUrl: './debug.component.css'
})
export class DebugComponent implements OnInit{
  

  private $users = inject(UsersService);

  policy = resource({
    params: () => ({}),
    loader: ({params}) => firstValueFrom(this.$users.getPolicy()),
  });


  async ngOnInit(){


    const session = await fetchAuthSession() ;
    const token: string = session.tokens!.idToken!.toString();

    const authorizer = "GamefaceAuthorizer";
    const query = `x-amz-customauthorizer-name=${authorizer}&token=${token}`;
                
    const client = mqtt.connect(`wss://${environment.awsMqttHost}:443/mqtt?`+query, {});
    let connectAttempts = 0;
    client.on('connect', function () {
        console.log('Connected')
    });

    client.on('error', function (err) {
        console.log(err);
    });

    client.on('close', function () {
        console.log('closed');
    });

    client.on('reconnect', () => {
      connectAttempts++;
      console.log(`Reconnecting... Attempt: ${connectAttempts}`);

      if (connectAttempts >= 10) {
          console.log('Maximum reconnect attempts reached. Ending connection.');
          client.end(); // Terminate the client connection
      }
    });

    client.on('message', function (topic, message) {
        // message is Buffer
        console.log(`Got ${message.toString()} on topic: "${topic}"`);
    })

  }
}
